<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-card>
                <v-card-text>
                    <equipment-selector v-model="equipment"></equipment-selector>
                    <variable-selector :equipment="equipment" v-model="variableX" label="Variable X"></variable-selector>
                    <variable-selector :equipment="equipment" v-model="variableY" label="Variable Y"></variable-selector>
                    <variable-selector :equipment="equipment" v-model="variableFacet" label="Variable Facet"></variable-selector>

                    <v-slider
                            thumb-label="always"
                            label="Facet Groups"
                            v-model="facetGroups"
                            :max="20"
                            :min="1"
                            :step="1"
                    ></v-slider>

                </v-card-text>
                <v-card-text>
                    <date-range-selector v-model="range"></date-range-selector>
                </v-card-text>
                    <v-switch
                            v-model="onOnly"
                            label="View Points when Chiller is On"
                    ></v-switch>
            </v-card>
        </v-flex>
        <v-flex xs12>
            <facet-plot
                     :variable-x="variableX.sensor_name"
                     :variable-y="variableY.sensor_name"
                     :facility_name="variableX.facility_name"
                     :equipment_name="variableX.equipment_name"
                     :date-range="range"
                     :on-only="onOnly"
                     :facet-groups="facetGroups"
                     :variable-facet="variableFacet.sensor_name"
            >
            </facet-plot>

        </v-flex>
    </v-layout>
</template>

<script>
import DateRangeSelector from '../components/DateRangeSelector'
import EquipmentSelector from '../components/EquipmentSelector'
import VariableSelector from '../components/VariableSelector'
import FacetPlot from '../components/FacetPlot'
export default {
  name: 'FacetPlots',
  components: { FacetPlot, VariableSelector, EquipmentSelector, DateRangeSelector },
  data() {
    return {
      onOnly: true,
      selected_var: null,
      value: 1,
      range: {start: '2018-01-01', end: '2019-06-30'},
      variableX: {sensor_name: null, facility_name: '', equipment_name: ''},
      variableY: {sensor_name: null, facility_name: '', equipment_name: ''},
      equipment: null,
      facetGroups:2,
      variableFacet: {sensor_name: null, facility_name: '', equipment_name: ''}
    }
  },
  watch: {
    selected_var() {
    }
  },

  computed: {

  }
}
</script>

<style scoped>

</style>
